import { render, staticRenderFns } from "./ItemLicenseSaveLayout.vue?vue&type=template&id=00a4d60a&scoped=true&"
import script from "./ItemLicenseSaveLayout.vue?vue&type=script&lang=js&"
export * from "./ItemLicenseSaveLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a4d60a",
  null
  
)

export default component.exports